import { webpTest } from '../../helpers/helpers';

const elementProto = Object.create(HTMLDivElement.prototype);
const webpSupports = webpTest;

let sources = {
	src: '',
	srcWebp: ''
};

elementProto.createdCallback = function() {}
elementProto.attachedCallback = function() {
	sources.src = this.dataset.src;
	sources.srcWebp = this.dataset.srcWebp;

	let src = sources.src;

	if (webpSupports && sources.srcWebp && sources.srcWebp.length > 0)
		src = sources.srcWebp;

	this.style.backgroundImage = `url(${src})`;
}
elementProto.detachedCallback = function() {}

document.registerElement('img-background', {
	prototype: elementProto,
	extends: 'div'
});